import { makeStyles } from "@material-ui/core/styles"
import { green } from "@material-ui/core/colors"

const useStyles = makeStyles((theme) => ({
  extraAttr: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  btnFullWidth: {
    width: "100%",
    minHeight: "40px",
    borderRadius: "12px",
    fontWeight: 500,
  },
  buttonsContainer: {
    backgroundColor: theme.palette.background100,
    minHeight: "72px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    gap: "8px",
    paddingTop: "16px",
    paddingBottom: "16px",
    paddingLeft: "24px",
    paddingRight: "24px",
  },
  btnWrapper: {
    position: "relative",
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  tituloNovaConversa: {
    height: "73px",
    padding: "24px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontFamily: "Roboto",
    fontSize: "20px",
    lineHeight: "25px",
    letterSpacing: "-0.25px",
    color: theme.palette.neutral400,
    backgroundColor: theme.palette.backgroundl100,
  },
  boxNovaConversa: {
    position: "absolute",
    right: 0,
    top: 0,
    margin: 0,
    minHeight: 816,
    width: 400,
    borderRadius: "12px",
    "@media (max-width: 768px)": {
      minWidth: "100%",
      maxWidth: "100%",
      minHeight: "100%",
      borderRadius: "0px",
    },
  },
  iconButton: {
    marginLeft: "auto",
    padding: "0px",
  },
  iconX: {
    color: theme.palette.neutral400,
  },
  content: {
    paddingLeft: "32px",
    paddingRight: "32px",
    borderTop: "1px solid rgba(0, 0, 0, 0.12)",
    backgroundColor: theme.palette.background200,
    "@media (max-width: 768px)": {
      paddingLeft: "7%",
      paddingRight: "7%",
    },
  },
  input: {
    backgroundColor: theme.palette.background100,
    borderRadius: "12px",
    marginTop: "12px",
    marginBottom: "12px",
    "& .MuiOutlinedInput-root": {
      borderRadius: "12px",
      "& fieldset": {
        borderColor: theme.palette.neutral300,
      },
    },
    "&:not(:first-of-type)": {
      marginTop: "20px",
    },
  },
  textField: {
    color: theme.palette.neutral400,
    border: theme.palette.neutral300,
    height: "30px",
    textAlign: "start",
  },
  label: {
    color: theme.palette.neutral400,
    "& .MuiInputLabel-shrink": { textAlign: "center", width: "100%" },
    "& .MuiFormLabel-asterisk": {
      display: "none",
    },
  },
  buttonBox: {
    paddingBottom: "16px",
    paddingTop: "16px",
    display: "flex",
    alignItems: "center",
    paddingLeft: "0px",
    paddingRight: "0px",
    marginLeft: "0px",
  },
  button: {
    letterSpacing: "-0.25%",
    lineHeight: "24px",
    fontFamily: "Roboto",
    fontSize: "16px",
    textTransform: "none",
    minWidth: "100%",
    height: "56px",
    borderRadius: "12px",
    "@media (max-width: 768px)": {
      width: "100%",
    },
  },
  slideIn: {
    animation: `$slideIn 0.5s forwards`,
  },
  slideOut: {
    animation: `$slideOut 0.5s forwards`,
  },
  "@keyframes slideIn": {
    from: { transform: "translateX(100%)", opacity: 0 },
    to: { transform: "translateX(0)", opacity: 1 },
  },
  "@keyframes slideOut": {
    from: { transform: "translateX(0)", opacity: 1 },
    to: { transform: "translateX(100%)", opacity: 0 },
  },
  formContainer: {
    width: "100%",
    "& .MuiGrid-container": {
      width: "100%",
    },
    "& .MuiGrid-item": {
      width: "100%",
    },
    "& .MuiGrid-grid-md-4": {
      maxWidth: "100% !important",
      flexBasis: "100% !important",
    },
    "& .MuiGrid-grid-md-6": {
      maxWidth: "100% !important",
      flexBasis: "100% !important",
    },
    "& .MuiGrid-grid-md-12": {
      maxWidth: "100% !important",
      flexBasis: "100% !important",
    },
    "& .MuiFormControl-root": {
      width: "100% !important",
    },
    "& .MuiTextField-root": {
      width: "100% !important",
    },
    "& .MuiInputBase-root": {
      width: "100% !important",
    },
  },
}))

export default useStyles
